import { Component, Input } from '@angular/core';
import { _buttonBaseComponent } from '../_button-base/_button-base.component';

@Component({
  selector: 'app-save-button',
  templateUrl: './save-button.component.html',
  styleUrls: ['./save-button.component.css']
})
export class SaveButtonComponent extends _buttonBaseComponent{
  @Input() showTickIcon = false; 
  
  constructor() {
    super();
    this.buttonText = 'General.Save'
  }

}
